import styled from 'styled-components';
import { colors } from '../colors';

const HeaderLeft = styled.div`
	display: flex;
	align-items: center;
	color: ${colors.BlueBase};
`;

export default HeaderLeft;
